import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import RichTimePicker from './layout.vue'
import {InputPreviewText} from '../PreviewText'

const TransformRichDatePicker = transformComponent(
  RichTimePicker,
  {
    change: 'input'
  }
)

export const DatePicker = connect(
  TransformRichDatePicker,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(InputPreviewText)
)

export default DatePicker
